<div class="panel">
  <div class="heading">
    <ng-content select="[heading]"></ng-content>
    @if (canCollapse) {
      <button (click)="toggleContent()"
              class="rounded-full bg-secondary text-white">
        @if (showContent) {
          <span class="sr-only">Klap dicht</span>
          <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" d="M18 12H6" />
          </svg>
        }
        @if (!showContent) {
          <span class="sr-only">Klap open</span>
          <svg class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" aria-hidden="true">
            <path stroke-linecap="round" stroke-linejoin="round" d="M12 6v12m6-6H6" />
          </svg>
        }
      </button>
    }
  </div>
  <div [ngClass]="{ 'show' : showContent }" class="content">
    @if (showContent) {
      <ng-content select="[content]"></ng-content>
    } @else {
      <ng-content select="[altContent]"></ng-content>
      <button (click)="toggleContent()"
              class="text-primary text-left"
              type="button">{{ 'common.button.change' | translate }}</button>
    }

  </div>

  <div class="footer">
    <ng-content select="[footer]"></ng-content>
  </div>
</div>
